import { PEOPLE_PAGE_BREAKPOINT } from '../../utils/constants'
import DesktopProfile from './desktop-profile'
import MobileProfile from './mobile-profile'

/**
 * Manages init/tear down of different modes depending on viewport width.
 */
const PeoplePage = (function () {
  // Available modes/UI versions of gallery/profile feature
  const uiModes = {
    mobile: 'mobile',
    desktop: 'desktop',
  }

  let mediaQuery = window.matchMedia(`(min-width: ${PEOPLE_PAGE_BREAKPOINT})`)
  let curMode
  let curComponent
  let curProfile

  /**
   * Initialise event listener for viewport size change
   */
  const initViewportSizeListener = () => {
    mediaQuery.addEventListener('change', handleViewportChange)
  }

  /**
   * Remove event listener for viewport size change
   */
  const killViewportSizeListener = () => {
    mediaQuery.removeEventListener('change', handleViewportChange)
  }

  /**
   * On viewport size change, check if UI mode needs to switch (between mobile/desktop layouts)
   */
  const handleViewportChange = () => {
    let newMode = mediaQuery.matches ? uiModes.desktop : uiModes.mobile

    // If required mode different from current, set them up/tear them down appropriately
    if (newMode !== curMode) {
      if (curComponent) killCurComponent()

      if (newMode === uiModes.mobile) {
        curMode = uiModes.mobile
        curComponent = MobileProfile
        curComponent.init(curProfile)
      } else {
        curMode = uiModes.desktop
        curComponent = DesktopProfile
        curComponent.init(curProfile)
      }
    }
  }

  /**
   * Run kill function of previous UI component to remove event listeners etc
   */
  const killCurComponent = () => {
    try {
      curComponent?.kill()
      curProfile = null
    } catch (e) {
      console.error(e)
    }
  }

  return {
    init: () => {
      if (document.querySelector('.js-people-feature')) {
        curMode = mediaQuery.matches ? uiModes.desktop : uiModes.mobile
        curComponent = curMode === uiModes.desktop ? DesktopProfile : MobileProfile
        curProfile = window.location.hash.replace('#', '')
        curComponent.init(curProfile)
        initViewportSizeListener()
      }
    },
    kill: () => {
      if (document.querySelector('.js-people-feature')) {
        killCurComponent()
        killViewportSizeListener()
      }
    },
  }
})()

export default PeoplePage
